"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoistureLoadStatus = void 0;
var MoistureLoadStatus;
(function (MoistureLoadStatus) {
    MoistureLoadStatus[MoistureLoadStatus["Created"] = 0] = "Created";
    MoistureLoadStatus[MoistureLoadStatus["SaveFailed"] = 31] = "SaveFailed";
    MoistureLoadStatus[MoistureLoadStatus["Saved"] = 32] = "Saved";
    MoistureLoadStatus[MoistureLoadStatus["CalculationFailed"] = 51] = "CalculationFailed";
    MoistureLoadStatus[MoistureLoadStatus["CalculationSuccess"] = 52] = "CalculationSuccess";
    MoistureLoadStatus[MoistureLoadStatus["LockFailed"] = 89] = "LockFailed";
    MoistureLoadStatus[MoistureLoadStatus["LockSuccess"] = 90] = "LockSuccess";
})(MoistureLoadStatus || (exports.MoistureLoadStatus = MoistureLoadStatus = {}));
//# sourceMappingURL=moisture-load-status.js.map